// extracted by mini-css-extract-plugin
module.exports = {"subProductLay":"SubProductItem_subProductLay__QgDWN","txt":"SubProductItem_txt__2teLE","img_wraps":"SubProductItem_img_wraps__2pX7h"};